import Notify from 'simple-notify';
import 'simple-notify/dist/simple-notify.css';

// Configure default styles for simple-notify
const defaultConfig = {
  position: 'top-right',
  autoClose: true,
  autoCloseTime: 4000,
  showCloseButton: true,
  showIcon: true,
  customClass: '',
  customWrapper: '',
  customContainer: ''
};

// Success toast (green)
export const toast = {
  success: (message) => {
    new Notify({
      status: 'success',
      title: 'Suksess',
      text: message,
      effect: 'fade',
      speed: 300,
      ...defaultConfig
    });
  },
  
  // Error toast (red)
  error: (message) => {
    new Notify({
      status: 'error',
      title: 'Feil',
      text: message,
      effect: 'fade',
      speed: 300,
      autoCloseTime: 6000, // Longer for errors
      ...defaultConfig
    });
  },
  
  // Info toast (blue)
  info: (message) => {
    new Notify({
      status: 'info',
      title: 'Info',
      text: message,
      effect: 'fade',
      speed: 300,
      ...defaultConfig
    });
  },
  
  // Warning toast (orange)
  warning: (message) => {
    new Notify({
      status: 'warning',
      title: 'Advarsel',
      text: message,
      effect: 'fade',
      speed: 300,
      autoCloseTime: 5000,
      ...defaultConfig
    });
  },

  // Confirm dialog using simple-notify
  confirm: (message) => {
    return new Promise((resolve) => {
      // Create a confirm-style notification with buttons
      const notification = new Notify({
        status: 'info',
        title: 'Bekreftelse',
        text: message,
        effect: 'fade',
        speed: 300,
        position: 'center',
        autoClose: false,
        showCloseButton: false,
        customWrapper: 'confirm-wrapper',
        customClass: 'confirm-notification',
        customContainer: `
          <div class="confirm-buttons" style="margin-top: 1rem; display: flex; gap: 0.5rem; justify-content: center;">
            <button class="confirm-yes btn" style="background: #4CAF50; color: white; border: none; padding: 0.5rem 1rem; border-radius: 4px; cursor: pointer;">Ja</button>
            <button class="confirm-no btn" style="background: #f44336; color: white; border: none; padding: 0.5rem 1rem; border-radius: 4px; cursor: pointer;">Nei</button>
          </div>
        `
      });

      // Add event listeners after notification is created
      setTimeout(() => {
        const yesBtn = document.querySelector('.simple-notify .confirm-yes');
        const noBtn = document.querySelector('.simple-notify .confirm-no');
        
        if (yesBtn) {
          yesBtn.onclick = () => {
            notification.close();
            resolve(true);
          };
        }
        
        if (noBtn) {
          noBtn.onclick = () => {
            notification.close();
            resolve(false);
          };
        }
      }, 100);
    });
  }
};

// For backward compatibility with existing alert() calls
export const showAlert = {
  success: toast.success,
  error: toast.error,
  info: toast.info,
  warning: toast.warning
};

// Backward compatible confirm function
export const showConfirm = toast.confirm;

export default toast;